import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../../../utils/Api";
import avaterPlaceholder from "../../../assets/img/avater.png";
import Post from "./Post.jsx";
import { formatPostTime } from "../../../utils/formatTime";

const PublicProfilePage = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const apiBase = API.defaults.baseURL?.replace(/\/api\/?$/, "") || "";

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await API.get(`/users/${id}`);
        setProfile(res.data?.data || null);
      } catch (error) {
        setProfile(null);
      }
    };
    const loadPosts = async () => {
      try {
        const res = await API.get(`/posts/user/${id}`);
        setPosts(res.data?.data || []);
      } catch {
        setPosts([]);
      }
    };
    loadProfile();
    loadPosts();
  }, [id]);

  const resolveAvatar = (url) =>
    url ? (url.startsWith("http") ? url : `${apiBase}${url}`) : "";

  if (!profile) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center text-gray-500">
        User not found.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-700">
            Back to Home
          </Link>
          <Link
            to={`/chat/${profile._id}`}
            className="text-sm bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
          >
            Message
          </Link>
        </div>

        <div className="flex items-center gap-4">
          <img
            src={resolveAvatar(profile.avatarUrl) || avaterPlaceholder}
            alt={profile.name || profile.username}
            className="w-20 h-20 rounded-full object-cover border"
          />
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {profile.name || profile.username}
            </h2>
            <p className="text-sm text-gray-500">@{profile.username}</p>
          </div>
        </div>

        <div className="mt-6 space-y-2 text-sm text-gray-600">
          <p><strong>Bio:</strong> {profile.bio || "No bio"}</p>
          <p><strong>Job:</strong> {profile.job || "Not set"}</p>
          <p><strong>Location:</strong> {profile.location || "Not set"}</p>
          <p><strong>Website:</strong> {profile.website || "Not set"}</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto mt-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Posts</h3>
        {posts.length > 0 ? (
          posts.map((post) => {
            const { timeAgo, fullDate } = formatPostTime(post.createdAt);
            return (
              <Post
                key={post._id}
                postId={post._id}
                username={post.author?.name || post.author?.username}
                avatar={post.author?.avatarUrl}
                userId={post.author?._id}
                handle={fullDate}
                time={timeAgo}
                content={post.content}
                imageUrl={post.imageUrl}
                likes={post.likes}
                comments={post.comments}
              />
            );
          })
        ) : (
          <div className="text-center text-gray-500 py-6 bg-white rounded-xl border">
            No posts available.
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicProfilePage;
